import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appButtonsHoverTable]'
})
export class ButtonsHoverTableDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('mouseover') onMouseOver() {
    this.showButtons();
  }

  @HostListener('mouseout') onMouseOut() {
    this.hideButtons();
  }

  private showButtons() {
    const actionButtons = this.el.nativeElement.querySelector('.hide-buttons');
    if (actionButtons) {
      this.renderer.removeClass(actionButtons, 'hide-buttons');
      this.renderer.addClass(actionButtons, 'show-buttons');
    }
  }

  private hideButtons() {
    const actionButtons = this.el.nativeElement.querySelector('.show-buttons');
    if (actionButtons) {
      this.renderer.removeClass(actionButtons, 'show-buttons');
      this.renderer.addClass(actionButtons, 'hide-buttons');
    }
  }

}
